module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_iterators.js
// module id = 35
// module chunks = 1 2